export default __webpack_public_path__ + "static/media/bell.fc8f1cdd.svg";